import { useState, useEffect, useRef } from 'react'

export default function useComponentVisible(initialIsVisible) {
  const [isFeedbackVisible, setIsFeedbackVisible] = useState(initialIsVisible)
  const [isBookmarkVisible, setIsBookmarkVisible] = useState(initialIsVisible)
  const ref1 = useRef(null)
  const ref2 = useRef(null)
  const handleClickOutsideFeedback = (event) => {
    if (ref1.current && !ref1.current.contains(event.target)) {
      setIsFeedbackVisible(false)
    }
  }
  const handleClickOutsideBookmark = (event) => {
    if (ref2.current && !ref2.current.contains(event.target)) {
      setIsBookmarkVisible(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutsideFeedback, true)
    document.addEventListener('click', handleClickOutsideBookmark, true)
    return () => {
      document.removeEventListener('click', handleClickOutsideFeedback, true)
      document.removeEventListener('click', handleClickOutsideBookmark, true)
    }
  })

  return { ref1, ref2, isFeedbackVisible, isBookmarkVisible }
}
